var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0043 1.97712C14.3242 3.22452 14.3242 5.82852 14.3242 5.82852C14.3242 5.82852 14.3242 8.43252 14.0043 9.67992C13.8265 10.3694 13.3064 10.9119 12.6477 11.0953C11.4514 11.4285 7.32422 11.4285 7.32422 11.4285C7.32422 11.4285 3.19912 11.4285 2.00072 11.0953C1.33922 10.9091 0.819819 10.3673 0.644119 9.67992C0.324219 8.43252 0.324219 5.82852 0.324219 5.82852C0.324219 5.82852 0.324219 3.22452 0.644119 1.97712C0.821919 1.28762 1.34202 0.745116 2.00072 0.561716C3.19912 0.228515 7.32422 0.228516 7.32422 0.228516C7.32422 0.228516 11.4514 0.228515 12.6477 0.561716C13.3092 0.747916 13.8286 1.28972 14.0043 1.97712ZM5.92422 8.27852L10.1242 5.82852L5.92422 3.37852V8.27852Z",
    fill: "url(#paint0_linear_4817_153849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4817_153849",
    x1: 7.32422,
    y1: -1.78748,
    x2: 7.32422,
    y2: 13.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0d140943576b6389b9abb9a2b3ed3c61.svg";
export { ForwardRef as ReactComponent };